import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './ColorItemImage.styles';

import { IMAGE_COMING_SOON } from '~/core/constants';
import { useRetailerSettings } from '~/core/hooks/useRetailerSettings';
import { ColorModel } from '~/core/models';
import { hasTrendingOrBestSelling, imgUrl } from '~/core/utils';
import ColorOptions from '~organisms/ColorOptions';

interface ColorItemImageProps {
  color: ColorModel;
  description: string;
  handleViewSlabClick: (color: ColorModel) => void;
  handleColorVisualizerChange: () => void;
  handleDesignClick: () => void;
  isSelectedColor: boolean;
}

const ColorItemImage = ({
  color,
  description,
  handleViewSlabClick,
  handleColorVisualizerChange,
  handleDesignClick,
  isSelectedColor,
}: ColorItemImageProps): JSX.Element => {
  const { t } = useTranslation();

  const { retailerFileSettings } = useRetailerSettings();

  const isVisualizerActive = useMemo(
    () => !!retailerFileSettings?.showVisualizer,
    [retailerFileSettings]
  );

  const trendLabel = hasTrendingOrBestSelling(color.features);

  return (
    <St.Container>
      {trendLabel && <St.OnTrend>{t(trendLabel).toUpperCase()}</St.OnTrend>}
      <img
        alt={description}
        src={imgUrl(color.swatchImageUrl, 300)}
        onError={(event) => {
          event.currentTarget.src = IMAGE_COMING_SOON;
        }}
      />
      <ColorOptions
        color={color}
        handleViewSlabClick={handleViewSlabClick}
        handleColorVisualizerChange={handleColorVisualizerChange}
        handleDesignClick={handleDesignClick}
        isVisualizerActive={isVisualizerActive}
        isSelectedColor={isSelectedColor}
      />
    </St.Container>
  );
};

export default ColorItemImage;
